import { render } from "./skills-form.vue?vue&type=template&id=f256350e&lang=true"
import script from "./skills-form.vue?vue&type=script&lang=js"
export * from "./skills-form.vue?vue&type=script&lang=js"

import "./skills-form.vue?vue&type=style&index=0&id=f256350e&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__